import React from "react";

interface Props {
  title: string;

  description: string;

  loading?: boolean;

  onClick: () => void;
}

const CacheActionCard: React.FC<Props> = ({
  title,
  description,
  loading,
  onClick,
}) => {
  return (
    <div className="rounded-xl border border-slate-200 bg-white p-5 shadow-sm">
      <h3 className="font-semibold text-slate-900">{title}</h3>

      <p className="mt-2 text-sm text-slate-500">{description}</p>

      <button
        type="button"
        onClick={onClick}
        disabled={loading}
        className="mt-4 rounded-lg border border-slate-300 px-4 py-2 text-sm hover:bg-slate-50"
      >
        {loading ? "Clearing..." : "Clear Cache"}
      </button>
    </div>
  );
};

export default CacheActionCard;
